/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiProgressStep
 */
export interface ApiProgressStep {
    /**
     * 
     * @type {number}
     * @memberof ApiProgressStep
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiProgressStep
     */
    nameKey?: string;
}

export function ApiProgressStepFromJSON(json: any): ApiProgressStep {
    return ApiProgressStepFromJSONTyped(json, false);
}

export function ApiProgressStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiProgressStep {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'nameKey': !exists(json, 'nameKey') ? undefined : json['nameKey'],
    };
}

export function ApiProgressStepToJSON(value?: ApiProgressStep | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'nameKey': value.nameKey,
    };
}

